export function isEnabled() {
  return process.env.SYSTEM_SPECS == 'true' || process.env.NODE_ENV !== 'test'
}

export { NGIE_API_VERSION as apiVersion, NGIE_JS_API_URL as apiURL } from 'environment'
